import { firstValueFrom } from 'rxjs';
import { ApplicationSelectionType } from '@portal-workspace/grow-shared-library';
import { ApplicationDialogService } from '../application-dialog-component/application-dialog.service';
import { KycVerificationComponent } from './kyc-verification.component';

/**
 * When leaving the KYC/AML tab with unsaved individual edits, prompts the user.
 * Returns true if navigation may proceed; false if the user chose to stay (caller
 * should have already reverted the tab index via revertToKycTab).
 */
export async function confirmLeaveKycAmlTab(opts: {
  previousSection: ApplicationSelectionType;
  nextSection: ApplicationSelectionType;
  kycVerification: KycVerificationComponent | undefined;
  dialogService: ApplicationDialogService;
  revertToKycTab: () => void;
}): Promise<boolean> {
  const { previousSection, nextSection, kycVerification, dialogService, revertToKycTab } = opts;
  if (previousSection !== 'kyc-aml' || nextSection === 'kyc-aml' || !kycVerification?.hasUnsavedChanges()) {
    return true;
  }

  const leave = await firstValueFrom(
    dialogService.openUnsavedChangesDialog(kycVerification.unsavedChangeLabels()).afterClosed(),
  );

  if (!leave) {
    revertToKycTab();
    return false;
  }
  return true;
}
